import { useBookingState } from '../state/booking.context'
import { stageIdOf } from '../lib/bookingConfig'

/**
 * Derives whether the Continue button should be enabled for the current stage.
 * Single source of truth — no manual SET_ALLOW_CONTINUE dispatches needed.
 */
export function useStageCanContinue(): boolean {
  const state = useBookingState()
  const stageId = stageIdOf(state.config, state.stage ?? 1)

  switch (stageId) {
    case 'extras':
      return state.extras.reduce((sum, e) => sum + e.quantity, 0) > 0

    case 'quantity': {
      const hasExtras = Boolean(state.config.extras)
      const ticketCount = state.quantities.reduce((sum, q) => sum + q.quantity, 0)
      const extrasTotal = state.extras.reduce((sum, e) => sum + e.quantity, 0)
      return hasExtras ? ticketCount > 0 && ticketCount === extrasTotal : ticketCount > 0
    }

    case 'datetime':
      return Boolean(state.session)

    case 'addons':
      return true

    case 'customer':
      return true

    case 'payment':
      return state.paymentReady

    default:
      return true
  }
}
